import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-6597">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-6598">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-6599">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-6600">
            <ArrowLeft className="w-4 h-4" data-id="element-6601" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-6602">NOIZA</div>
          <div className="w-20" data-id="element-6603" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-6604">
        <div className="mb-12" data-id="element-6605">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-6606">
            <FileText className="w-6 h-6 text-white/80" data-id="element-6607" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-6608">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-6609">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-6610">
          <section data-id="element-6611">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6612">
              <span className="text-[#006847]" data-id="element-6613">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6614">
              <p data-id="element-6615">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-6616">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6617">
                <li data-id="element-6618">Haber leído íntegramente este documento</li>
                <li data-id="element-6619">Comprender su contenido en su totalidad</li>
                <li data-id="element-6620">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-6621">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-6622">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6623">
              <span className="text-[#006847]" data-id="element-6624">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6625">
              <p data-id="element-6626">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6627">
                <li data-id="element-6628">Software como servicio (SaaS)</li>
                <li data-id="element-6629">Marketplace digital gastronómico</li>
                <li data-id="element-6630">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-6631">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6632">
                <li data-id="element-6633">Mostrar su menú digital</li>
                <li data-id="element-6634">Recibir pedidos de clientes</li>
                <li data-id="element-6635">Gestionar su operación interna</li>
                <li data-id="element-6636">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-6637">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-6638">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6639">
              <span className="text-[#006847]" data-id="element-6640">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6641">
              <p data-id="element-6642">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6643">
                <li data-id="element-6644">No es proveedor de alimentos</li>
                <li data-id="element-6645">No participa en la preparación de productos</li>
                <li data-id="element-6646">No manipula alimentos en ningún momento</li>
                <li data-id="element-6647">No realiza entregas ni logística</li>
                <li data-id="element-6648">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-6649">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-6650">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-6651">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6652">
              <span className="text-[#006847]" data-id="element-6653">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-6654">
              <p data-id="element-6655">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-6656">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6657">
                <li data-id="element-6658">El restaurante es el único responsable de su operación</li>
                <li data-id="element-6659">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-6660">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-6661">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6662">
                <li data-id="element-6663">Precios</li>
                <li data-id="element-6664">Menú</li>
                <li data-id="element-6665">Horarios</li>
                <li data-id="element-6666">Métodos de pago</li>
                <li data-id="element-6667">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6668">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6669">
              <span className="text-[#006847]" data-id="element-6670">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-6671">
              <div data-id="element-6672">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6673">
                  5.1. Alcance general
                </h3>
                <p data-id="element-6674">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-6675">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6676">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-6677">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6678">
                  <li data-id="element-6679">Calidad de los alimentos</li>
                  <li data-id="element-6680">Estado, frescura o preparación</li>
                  <li data-id="element-6681">Ingredientes utilizados</li>
                  <li data-id="element-6682">Contaminación cruzada</li>
                  <li data-id="element-6683">Problemas de higiene o salubridad</li>
                  <li data-id="element-6684">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6685">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-6686">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6687">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-6688">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6689">
                  <li data-id="element-6690">Retrasos en la entrega</li>
                  <li data-id="element-6691">Pérdida de pedidos</li>
                  <li data-id="element-6692">Entregas incompletas</li>
                  <li data-id="element-6693">Errores en dirección</li>
                  <li data-id="element-6694">Conducta de repartidores</li>
                  <li data-id="element-6695">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-6696">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6697">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-6698">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-6699">
                  <li data-id="element-6700">Recepción de pagos</li>
                  <li data-id="element-6701">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-6702">Manejo de efectivo</li>
                  <li data-id="element-6703">Confirmación de pagos</li>
                  <li data-id="element-6704">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-6705">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6706">
                  <li data-id="element-6707">Pagos no recibidos</li>
                  <li data-id="element-6708">Comprobantes falsos</li>
                  <li data-id="element-6709">Errores en montos</li>
                  <li data-id="element-6710">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-6711">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6712">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-6713">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6714">
                  <li data-id="element-6715">Reclamos de clientes</li>
                  <li data-id="element-6716">Reembolsos</li>
                  <li data-id="element-6717">Cancelaciones</li>
                  <li data-id="element-6718">Disputas</li>
                  <li data-id="element-6719">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6720">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-6721">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6722">
              <span className="text-[#006847]" data-id="element-6723">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-6724">
              <p data-id="element-6725">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6726">
                <li data-id="element-6727">Responsable</li>
                <li data-id="element-6728">Legal</li>
                <li data-id="element-6729">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-6730">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6731">
                <li data-id="element-6732">Publicar información falsa</li>
                <li data-id="element-6733">Manipular precios de forma engañosa</li>
                <li data-id="element-6734">Simular disponibilidad inexistente</li>
                <li data-id="element-6735">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6736">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6737">
              <span className="text-[#006847]" data-id="element-6738">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-6739">
              <p data-id="element-6740">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6741">
                <li data-id="element-6742">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-6743">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-6744">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6745">
                <li data-id="element-6746">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-6747">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-6748">
                    <li data-id="element-6749">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-6750">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-6751">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6752">
              <span className="text-[#006847]" data-id="element-6753">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-6754">
              <p data-id="element-6755">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6756">
                <li data-id="element-6757">Menú digital</li>
                <li data-id="element-6758">Gestión de pedidos</li>
                <li data-id="element-6759">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-6760">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6761">
                  <p className="font-medium text-white mb-2" data-id="element-6762">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6763">
                    <li data-id="element-6764">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6765">
                  <p className="font-medium text-white mb-2" data-id="element-6766">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6767">
                    <li data-id="element-6768">Propiedad del software</li>
                    <li data-id="element-6769">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-6770">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-6771">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6772">
              <span className="text-[#006847]" data-id="element-6773">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6774">
              <p data-id="element-6775">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6776">
                <li data-id="element-6777">Disponibilidad continua</li>
                <li data-id="element-6778">Funcionamiento sin interrupciones</li>
                <li data-id="element-6779">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-6780">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6781">
                <li data-id="element-6782">Fallas técnicas</li>
                <li data-id="element-6783">Actualizaciones</li>
                <li data-id="element-6784">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-6785">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-6786">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6787">
              <span className="text-[#006847]" data-id="element-6788">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-6789">
              <p data-id="element-6790">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6791">
                <li data-id="element-6792">No está garantizada permanentemente</li>
                <li data-id="element-6793">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-6794">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6795">
                <li data-id="element-6796">Destacar o no restaurantes</li>
                <li data-id="element-6797">Modificar posiciones</li>
                <li data-id="element-6798">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6799">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6800">
              <span className="text-[#006847]" data-id="element-6801">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-6802">
              <p data-id="element-6803">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6804">
                <li data-id="element-6805">Cumplir con los pagos acordados</li>
                <li data-id="element-6806">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-6807">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6808">
                <li data-id="element-6809">Suspender el servicio</li>
                <li data-id="element-6810">Limitar funcionalidades</li>
                <li data-id="element-6811">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6812">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6813">
              <span className="text-[#006847]" data-id="element-6814">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6815">
              <p data-id="element-6816">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6817">
                <li data-id="element-6818">Incumplimiento de términos</li>
                <li data-id="element-6819">Uso indebido</li>
                <li data-id="element-6820">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-6821">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-6822">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6823">
              <span className="text-[#006847]" data-id="element-6824">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-6825">
              <p data-id="element-6826">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-6827">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-6828">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6829">
              <span className="text-[#006847]" data-id="element-6830">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-6831">
              <p data-id="element-6832">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6833">
                <li data-id="element-6834">Pérdidas económicas</li>
                <li data-id="element-6835">Daños indirectos</li>
                <li data-id="element-6836">Lucro cesante</li>
                <li data-id="element-6837">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6838">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6839">
              <span className="text-[#006847]" data-id="element-6840">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-6841">
              <p data-id="element-6842">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-6843">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6844">
              <span className="text-[#006847]" data-id="element-6845">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-6846">
              <p className="font-medium" data-id="element-6847">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-6848">
                <li data-id="element-6849">Ha leído este documento completo</li>
                <li data-id="element-6850">Comprende su alcance</li>
                <li data-id="element-6851">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}